import React, {
  useEffect,
  useRef,
  useState
}                                 from 'react';
import { useSelector }            from 'react-redux';
import useHeartBeatenPane         from "../../../hooks/useHeartBeatenPane";
import useIsMounted               from '../../../hooks/useIsMounted';
import useObjectFitElement        from "../../../hooks/useObjectFitElement";
import { BrowseFrameHTMLElement } from "../../../services/types";
import { ApplicationState }       from '../../../store';
import { BrowseState }            from '../../../store/browse/types';
import { CamerasState }           from '../../../store/cameras/types';
import { fetchPaneTime }          from "../../../utils";


interface Props {
  src: any,
  alt: string,
  pane: number,
  className: string,
  onload: () => void,
  onerror: (el: HTMLImageElement | null | undefined) => void,
  time?: number,
}

const ImagePaneComponent: React.FC<Props> = ({src, alt, className, pane, time, onload, onerror}) => {
  const ref = useRef<BrowseFrameHTMLElement | null>(null);
  const {currentCameras} = useSelector<ApplicationState, CamerasState>(state => state.cameras);
  const {browsePanes} = useSelector<ApplicationState, BrowseState>(state => state.browse);
  const error = browsePanes[pane] && browsePanes[pane].error;

  const [source, setSource] = useState<string | null>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const isMounted = useIsMounted();
  const reload = currentCameras[pane] && currentCameras[pane].reload;

  useHeartBeatenPane(pane);

  useEffect(() => {
    if (src) {
      setSource(src);
      fetchPaneTime(pane);
    }

    return () => {
      setSource(null);
    }
  }, [src, reload]);

  useEffect(() => {
    if (ref.current) {
      ref.current.onload = () => {
        if (isMounted.current) {
          onload();
          setIsLoaded(true);
        }
      };
      ref.current.onerror = () => {
        if (isMounted.current) {
          setTimeout(() => {
            isMounted.current && setSource(src);
          }, 100);

          setIsLoaded(false);
          onerror(ref.current);
        }
      }
    }
    return () => {
      if (ref.current) {
        ref.current.onerror = null;
        ref.current.onload = null;
      }
    }
  }, [source]);

  useObjectFitElement(ref);

  return (
    <>
      {
        src && !error ? <img src={source ? source : ''}
                             alt={alt}
                             ref={ref}
                             draggable={false}
                             className={className}
                             id={'thumbnail-' + pane}
                             style={{opacity: isLoaded ? 1 : 0}}
          />
          : null
      }
    </>

  );
};

export default ImagePaneComponent;